import { MaterialDesignContent, ProviderContext, SnackbarOrigin, VariantType, useSnackbar, closeSnackbar } from 'notistack';
import React from 'react';
import styled from 'styled-components';

let useSnackBarRef: ProviderContext;

export const SnackbarUtilitiesConfig: React.FC = () => {
  useSnackBarRef = useSnackbar();
  return null;
};

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  padding: 4px 8px;
  margin-left: 12px;
  opacity: 0.8;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

export const SnackbarUtilities = {
  toast(message: string, variant: VariantType = 'default') {
    useSnackBarRef.enqueueSnackbar(message, {
      variant,
      action: (key) => <CloseButton onClick={() => closeSnackbar(key)}>✕</CloseButton>,
    });
  },
  success(message: string) {
    this.toast(message, 'success');
  },
  error(message: string) {
    this.toast(message, 'error');
  },
  info(message: string) {
    this.toast(message, 'info');
  },
  warning(message: string) {
    this.toast(message, 'warning');
  },
};

export const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#2D7738',
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#ff4d4f',
  },
}));

export const snackbarOriginOptions: SnackbarOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export const snackbarComponentsOptions: any = {
  error: StyledMaterialDesignContent,
};

export const AUTO_HIDE_DURATION = 5000;
